import { Typography } from "../typography";
import { FormControlError } from "../form-control-error";
import { View } from "@/components/ui";
import { InputPhoneNumberContent } from "./input-phone-number-content";

export type InputPhoneNumberProps = {
  className?: string;
  inputClassName?: string;
  label?: string;
  error?: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const InputPhoneNumber = ({
  className,
  inputClassName,
  label,
  error,
  value,
  onChange,
  disabled,
}: InputPhoneNumberProps) => {
  return (
    <View className="flex flex-col gap-1">
      {label && (
        <Typography variant="label-sm" color={"foreground-default"}>
          {label}
        </Typography>
      )}
      <View className={className}>
        <InputPhoneNumberContent
          value={value}
          onChange={onChange}
          inputClassName={inputClassName}
          error={error}
          disabled={disabled}
        />
      </View>
      {error && <FormControlError error={error} />}
    </View>
  );
};
